// Plan/tenant feature picking with dependency rules:
//  - turning a feature ON also turns on everything it needs (transitively);
//  - turning a feature OFF also turns OFF selected dependents (transitively).
const closure = (key, byKey) => {
  const out = new Set();
  const walk = (k) => (byKey[k]?.depends_on || []).forEach((d) => { if (!out.has(d)) { out.add(d); walk(d); } });
  walk(key);
  return out;
};

export function toggleWithDeps(selectedKeys, key, features) {
  const byKey = Object.fromEntries((features || []).map((f) => [f.key, f]));
  const set = new Set(selectedKeys || []);
  if (!set.has(key)) {
    set.add(key);
    const added = [...closure(key, byKey)].filter((d) => !set.has(d) && !byKey[d]?.always_on);
    added.forEach((d) => set.add(d));
    return { keys: [...set], added, blockedBy: [] };
  }
  const removed = [...set].filter((k) => k === key || closure(k, byKey).has(key));
  removed.forEach((k) => set.delete(k));
  return { keys: [...set], added: [], removed, blockedBy: [] };
}
